import LockFilledIcon from '../Icon/LockFilledIcon.js';
import UnlockFilledIcon from '../Icon/UnlockFilledIcon.js';

//
var script = {
  name: 'LockSwitch',
  components: {
    LockFilledIcon,
    UnlockFilledIcon
  },
  props: {
    value: {
      type: [Number, String, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'regular'
    }
  },

  data() {
    return {
      id: undefined
    };
  },

  computed: {
    iconSize() {
      return this.size === 'large' ? 'xsmall' : 'xxsmall';
    }

  },

  created() {
    // eslint-disable-next-line
    this.id = this._uuid;
  },

  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Toggle/LockSwitch.vue_rollup-plugin-vue=script.js